export enum CargoColumnType {
  String = "string",
  Int = "int",
  Bool = "bool",
  Decimal = "decimal",
  DateTime = "dateTime",
}

export interface CargoColumnCreateModel {
  length: number | null;
  name: string;
  precision: number | null;
  scale: number | null;
  type: CargoColumnType | "";
}
